// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__rIvne","amount":"Amount_amount__1W0ep","tip":"Amount_tip__28oIr","tipHeader":"Amount_tipHeader__1KNCp","tipsWrap":"Amount_tipsWrap__3TkpW"};